<template>
  <transition name="midia-fade">
    <div
      v-if="visivel"
      class="midia-overlay"
      @keydown.esc="fechar"
      @keydown.left="navegar(-1)"
      @keydown.right="navegar(1)"
      tabindex="0"
      ref="overlay"
    >
      <!-- Header estilo WhatsApp -->
      <div class="midia-header">
        <!-- Esquerda: info do remetente -->
        <div class="midia-header-info">
          <div class="midia-avatar">
            <svg viewBox="0 0 48 48" height="40" width="40" fill="none">
              <path d="M24 23q-1.857 0-3.178-1.322Q19.5 20.357 19.5 18.5t1.322-3.178T24 14t3.178 1.322Q28.5 16.643 28.5 18.5t-1.322 3.178T24 23m-6.75 10q-.928 0-1.59-.66-.66-.662-.66-1.59v-.9q0-.956.492-1.758A3.3 3.3 0 0 1 16.8 26.87a16.7 16.7 0 0 1 3.544-1.308q1.8-.435 3.656-.436 1.856 0 3.656.436T31.2 26.87q.816.422 1.308 1.223T33 29.85v.9q0 .928-.66 1.59-.662.66-1.59.66z" fill="rgba(255,255,255,0.5)"/>
            </svg>
          </div>
          <div class="midia-header-text">
            <span class="midia-sender-name">{{ nomeRemetente }}</span>
            <span class="midia-send-time">{{ dataHora }}</span>
          </div>
        </div>

        <!-- Direita: ações -->
        <div class="midia-header-actions">
          <!-- Zoom - -->
          <button
            class="midia-icon-btn"
            title="Menos zoom"
            :disabled="escala <= 0.2"
            @click="zoomOut"
          >
            <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
              <path d="M8 10.5C7.71667 10.5 7.47917 10.4042 7.2875 10.2125C7.09583 10.0208 7 9.78333 7 9.5C7 9.21667 7.09583 8.97917 7.2875 8.7875C7.47917 8.59583 7.71667 8.5 8 8.5H11C11.2833 8.5 11.5208 8.59583 11.7125 8.7875C11.9042 8.97917 12 9.21667 12 9.5C12 9.78333 11.9042 10.0208 11.7125 10.2125C11.5208 10.4042 11.2833 10.5 11 10.5H8ZM9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L20.3 18.9C20.4833 19.0833 20.575 19.3167 20.575 19.6C20.575 19.8833 20.4833 20.1167 20.3 20.3C20.1167 20.4833 19.8833 20.575 19.6 20.575C19.3167 20.575 19.0833 20.4833 18.9 20.3L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"/>
            </svg>
          </button>

          <!-- Zoom + -->
          <button
            class="midia-icon-btn"
            title="Mais zoom"
            :disabled="escala >= 5"
            @click="zoomIn"
          >
            <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
              <path d="M8.5 10.5H7.5C7.21667 10.5 6.97917 10.4042 6.7875 10.2125C6.59583 10.0208 6.5 9.78333 6.5 9.5C6.5 9.21667 6.59583 8.97917 6.7875 8.7875C6.97917 8.59583 7.21667 8.5 7.5 8.5H8.5V7.5C8.5 7.21667 8.59583 6.97917 8.7875 6.7875C8.97917 6.59583 9.21667 6.5 9.5 6.5C9.78333 6.5 10.0208 6.59583 10.2125 6.7875C10.4042 6.97917 10.5 7.21667 10.5 7.5V8.5H11.5C11.7833 8.5 12.0208 8.59583 12.2125 8.7875C12.4042 8.97917 12.5 9.21667 12.5 9.5C12.5 9.78333 12.4042 10.0208 12.2125 10.2125C12.0208 10.4042 11.7833 10.5 11.5 10.5H10.5V11.5C10.5 11.7833 10.4042 12.0208 10.2125 12.2125C10.0208 12.4042 9.78333 12.5 9.5 12.5C9.21667 12.5 8.97917 12.4042 8.7875 12.2125C8.59583 12.0208 8.5 11.7833 8.5 11.5V10.5ZM9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L20.3 18.9C20.4833 19.0833 20.575 19.3167 20.575 19.6C20.575 19.8833 20.4833 20.1167 20.3 20.3C20.1167 20.4833 19.8833 20.575 19.6 20.575C19.3167 20.575 19.0833 20.4833 18.9 20.3L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"/>
            </svg>
          </button>

          <!-- Responder -->
          <button
            v-if="midiaAtual && midiaAtual.remetente === 'cliente'"
            class="midia-icon-btn"
            title="Responder"
            @click="responder"
          >
            <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
              <path d="M6.82502 12L9.72502 14.9C9.92502 15.1 10.0209 15.3333 10.0125 15.6C10.0042 15.8667 9.90002 16.1 9.70002 16.3C9.50002 16.4833 9.26669 16.5792 9.00002 16.5875C8.73336 16.5958 8.50002 16.5 8.30002 16.3L3.70002 11.7C3.50002 11.5 3.40002 11.2667 3.40002 11C3.40002 10.7333 3.50002 10.5 3.70002 10.3L8.30002 5.69999C8.48336 5.51665 8.71252 5.42499 8.98752 5.42499C9.26252 5.42499 9.50002 5.51665 9.70002 5.69999C9.90002 5.89999 10 6.13749 10 6.41249C10 6.68749 9.90002 6.92499 9.70002 7.12499L6.82502 9.99999H16C17.3834 9.99999 18.5625 10.4875 19.5375 11.4625C20.5125 12.4375 21 13.6167 21 15V18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5209 18.9042 20.2834 19 20 19C19.7167 19 19.4792 18.9042 19.2875 18.7125C19.0959 18.5208 19 18.2833 19 18V15C19 14.1667 18.7084 13.4583 18.125 12.875C17.5417 12.2917 16.8334 12 16 12H6.82502Z"/>
            </svg>
          </button>

          <!-- Reagir -->
          <div v-if="midiaAtual && midiaAtual.remetente === 'cliente'" class="midia-reagir-wrapper">
            <button
              class="midia-icon-btn"
              title="Reagir"
              @click.stop="showReactionPicker = !showReactionPicker"
            >
              <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
                <path d="M15.5 11C15.9167 11 16.2708 10.8542 16.5625 10.5625C16.8542 10.2708 17 9.91667 17 9.5C17 9.08333 16.8542 8.72917 16.5625 8.4375C16.2708 8.14583 15.9167 8 15.5 8C15.0833 8 14.7292 8.14583 14.4375 8.4375C14.1458 8.72917 14 9.08333 14 9.5C14 9.91667 14.1458 10.2708 14.4375 10.5625C14.7292 10.8542 15.0833 11 15.5 11ZM8.5 11C8.91667 11 9.27083 10.8542 9.5625 10.5625C9.85417 10.2708 10 9.91667 10 9.5C10 9.08333 9.85417 8.72917 9.5625 8.4375C9.27083 8.14583 8.91667 8 8.5 8C8.08333 8 7.72917 8.14583 7.4375 8.4375C7.14583 8.72917 7 9.08333 7 9.5C7 9.91667 7.14583 10.2708 7.4375 10.5625C7.72917 10.8542 8.08333 11 8.5 11ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM12 17.5C12.9667 17.5 13.8583 17.2667 14.675 16.8C15.4917 16.3333 16.15 15.7 16.65 14.9C16.75 14.7 16.7417 14.5 16.625 14.3C16.5083 14.1 16.3333 14 16.1 14H7.9C7.66667 14 7.49167 14.1 7.375 14.3C7.25833 14.5 7.25 14.7 7.35 14.9C7.85 15.7 8.5125 16.3333 9.3375 16.8C10.1625 17.2667 11.05 17.5 12 17.5Z"/>
              </svg>
            </button>
            <div v-if="showReactionPicker" class="midia-reaction-picker" @click.stop>
              <span
                v-for="emoji in reactionEmojis"
                :key="emoji"
                class="midia-reaction-emoji"
                @click="enviarReacao(emoji)"
              >{{ emoji }}</span>
            </div>
          </div>

          <!-- Baixar -->
          <a
            v-if="midiaAtual && midiaAtual.url"
            :href="midiaAtual.url"
            download
            target="_blank"
            class="midia-icon-btn"
            title="Baixar"
            @click.stop
          >
            <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
              <path d="M12 15.57a1.1 1.1 0 0 1-.38-.06.88.88 0 0 1-.32-.21l-3.6-3.6a.92.92 0 0 1-.29-.7c.01-.27.1-.5.29-.7.2-.2.44-.3.71-.31.28-.01.52.08.71.29L11 12.14V5c0-.28.1-.52.29-.71.19-.2.43-.29.71-.29.28 0 .52.1.71.29.2.19.29.43.29.71v7.15l1.88-1.88c.2-.2.43-.3.7-.28a1.02 1.02 0 0 1 1 1.01c.02.27-.08.5-.28.7l-3.6 3.6c-.1.1-.2.17-.32.21a1.1 1.1 0 0 1-.38.06ZM6 20c-.55 0-1.02-.2-1.41-.59-.4-.39-.59-.86-.59-1.41v-2c0-.28.1-.52.29-.71.19-.2.43-.29.71-.29.28 0 .52.1.71.29.2.19.29.43.29.71v2h12v-2c0-.28.1-.52.29-.71.19-.2.43-.29.71-.29.28 0 .52.1.71.29.2.19.29.43.29.71v2c0 .55-.2 1.02-.59 1.41-.39.4-.86.59-1.41.59H6Z"/>
            </svg>
          </a>

          <!-- Fechar -->
          <button class="midia-icon-btn" title="Fechar" @click="fechar">
            <svg viewBox="0 0 24 24" height="22" width="22" fill="currentColor">
              <path d="m12 13.4-4.9 4.9a.95.95 0 0 1-.7.27.95.95 0 0 1-.7-.27.95.95 0 0 1-.28-.7c0-.28.1-.52.28-.7l4.9-4.9-4.9-4.9a.95.95 0 0 1-.28-.7.95.95 0 0 1 .97-.98c.3 0 .53.1.71.28l4.9 4.9 4.9-4.9a.95.95 0 0 1 .7-.27c.28 0 .52.09.7.27.18.18.27.42.27.7 0 .28-.09.52-.27.7L13.4 12l4.9 4.9c.18.18.27.42.27.7 0 .28-.09.52-.27.7a.95.95 0 0 1-.7.27.95.95 0 0 1-.7-.27L12 13.4Z"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Botão anterior -->
      <button
        v-if="indiceLista > 0"
        class="midia-nav-btn midia-nav-btn--left"
        @click.stop="navegar(-1)"
        aria-label="Anterior"
      >
        <svg viewBox="0 0 24 24" height="24" width="24" fill="currentColor">
          <path d="M10.8 12L14.7 15.9C14.8833 16.0834 14.975 16.3167 14.975 16.6C14.975 16.8834 14.8833 17.1167 14.7 17.3C14.5167 17.4834 14.2833 17.575 14 17.575C13.7167 17.575 13.4833 17.4834 13.3 17.3L8.7 12.7C8.6 12.6 8.52917 12.4917 8.4875 12.375C8.44584 12.2584 8.425 12.1334 8.425 12C8.425 11.8667 8.44584 11.7417 8.4875 11.625C8.52917 11.5084 8.6 11.4 8.7 11.3L13.3 6.70005C13.4833 6.51672 13.7167 6.42505 14 6.42505C14.2833 6.42505 14.5167 6.51672 14.7 6.70005C14.8833 6.88338 14.975 7.11672 14.975 7.40005C14.975 7.68338 14.8833 7.91672 14.7 8.10005L10.8 12Z"/>
        </svg>
      </button>

      <!-- Conteúdo central -->
      <div class="midia-content" @click.self="fecharSeNaoReacao">
        <!-- Imagem -->
        <div
          v-if="midiaAtual && midiaAtual.tipo === 'image' && midiaAtual.url"
          class="midia-img-wrapper"
          :style="wrapperStyle"
          @mousedown="iniciarPan"
          @wheel.prevent="onWheel"
        >
          <img
            ref="imagem"
            :src="midiaAtual.url"
            class="midia-img"
            draggable="false"
            alt="Imagem"
            @load="onImgLoad"
          >
        </div>

        <!-- Vídeo -->
        <video
          v-else-if="midiaAtual && midiaAtual.tipo === 'video' && midiaAtual.url"
          :src="midiaAtual.url"
          class="midia-video"
          controls
          autoplay
          @click.stop
        />

        <div v-else class="midia-unsupported">
          Tipo de mídia não suportado.
        </div>
      </div>

      <!-- Botão próximo -->
      <button
        v-if="indiceLista < lista.length - 1"
        class="midia-nav-btn midia-nav-btn--right"
        @click.stop="navegar(1)"
        aria-label="Avançar"
      >
        <svg viewBox="0 0 24 24" height="24" width="24" fill="currentColor">
          <path d="M12.6 12L8.7 8.10005C8.51667 7.91672 8.425 7.68338 8.425 7.40005C8.425 7.11672 8.51667 6.88338 8.7 6.70005C8.88334 6.51672 9.11667 6.42505 9.4 6.42505C9.68334 6.42505 9.91667 6.51672 10.1 6.70005L14.7 11.3C14.8 11.4 14.8708 11.5084 14.9125 11.625C14.9542 11.7417 14.975 11.8667 14.975 12C14.975 12.1334 14.9542 12.2584 14.9125 12.375C14.8708 12.4917 14.8 12.6 14.7 12.7L10.1 17.3C9.91667 17.4834 9.68334 17.575 9.4 17.575C9.11667 17.575 8.88334 17.4834 8.7 17.3C8.51667 17.1167 8.425 16.8834 8.425 16.6C8.425 16.3167 8.51667 16.0834 8.7 15.9L12.6 12Z"/>
        </svg>
      </button>

      <!-- Legenda -->
      <div v-if="midiaAtual && (midiaAtual.texto || midiaAtual.conteudo)" class="midia-caption">
        {{ midiaAtual.texto || midiaAtual.conteudo }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalMidia',
  props: {
    midia: { type: Object, default: null },
    visivel: { type: Boolean, default: false },
    lista: { type: Array, default: () => [] },
    cliente: { type: Object, default: null },
  },
  data() {
    return {
      indiceLista: 0,
      escala: 1,
      pan: { x: 0, y: 0 },
      panAtivo: false,
      panOrigem: { x: 0, y: 0 },
      showReactionPicker: false,
      reactionEmojis: ['👍', '👎', '❤️', '😂', '😮', '😢', '😡', '✅'],
    }
  },
  computed: {
    midiaAtual() {
      if (this.lista && this.lista.length > 0) {
        return this.lista[this.indiceLista] || null
      }
      return this.midia
    },
    nomeRemetente() {
      const m = this.midiaAtual
      if (!m) return ''
      if (m.remetente === 'atendente') return 'Você'
      if (this.cliente) {
        if (this.cliente.cliente && this.cliente.cliente.name) return this.cliente.cliente.name
        if (this.cliente.nome) return this.cliente.nome
      }
      return 'Cliente'
    },
    dataHora() {
      const m = this.midiaAtual
      if (!m || !m.timestamp) return ''
      try {
        const d = new Date(m.timestamp)
        const hoje = new Date()
        const isHoje = d.toDateString() === hoje.toDateString()
        const hora = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        if (isHoje) return `Hoje às ${hora}`
        return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ` às ${hora}`
      } catch {
        return ''
      }
    },
    wrapperStyle() {
      return {
        transform: `translate(${this.pan.x}px, ${this.pan.y}px) scale(${this.escala})`,
        cursor: this.escala > 1 ? (this.panAtivo ? 'grabbing' : 'grab') : 'default',
      }
    },
  },
  watch: {
    visivel(val) {
      if (val) {
        this.$nextTick(() => {
          this.sincronizarIndice()
          this.resetarTransform()
          this.$refs.overlay && this.$refs.overlay.focus()
        })
        document.addEventListener('mousemove', this.moverPan)
        document.addEventListener('mouseup', this.encerrarPan)
        document.addEventListener('click', this.fecharReactionPicker)
      } else {
        this.resetar()
        document.removeEventListener('mousemove', this.moverPan)
        document.removeEventListener('mouseup', this.encerrarPan)
        document.removeEventListener('click', this.fecharReactionPicker)
      }
    },
  },
  methods: {
    sincronizarIndice() {
      if (!this.lista || this.lista.length === 0 || !this.midia) {
        this.indiceLista = 0
        return
      }
      let idx = this.lista.findIndex(m => m === this.midia)
      if (idx < 0 && this.midia._id) {
        idx = this.lista.findIndex(m => m._id === this.midia._id)
      }
      if (idx < 0 && this.midia.id) {
        idx = this.lista.findIndex(m => m.id === this.midia.id)
      }
      if (idx < 0 && this.midia.url) {
        idx = this.lista.findIndex(m => m.url === this.midia.url)
      }
      this.indiceLista = idx >= 0 ? idx : 0
    },
    navegar(delta) {
      const novoIndice = this.indiceLista + delta
      if (novoIndice >= 0 && novoIndice < this.lista.length) {
        this.indiceLista = novoIndice
        this.resetarTransform()
        this.showReactionPicker = false
      }
    },
    fechar() {
      this.$emit('fechar')
    },
    fecharSeNaoReacao() {
      if (this.showReactionPicker) {
        this.showReactionPicker = false
        return
      }
      this.fechar()
    },
    fecharReactionPicker() {
      this.showReactionPicker = false
    },
    responder() {
      if (this.midiaAtual) {
        this.$emit('responder', this.midiaAtual)
      }
    },
    enviarReacao(emoji) {
      this.showReactionPicker = false
      if (this.midiaAtual) {
        this.$emit('reagir', this.midiaAtual, emoji)
      }
    },
    resetar() {
      this.resetarTransform()
      this.showReactionPicker = false
    },
    resetarTransform() {
      this.escala = 1
      this.pan = { x: 0, y: 0 }
      this.panAtivo = false
    },
    onImgLoad() {
      this.resetarTransform()
    },
    zoomIn() {
      this.escala = Math.min(5, this.escala + 0.25)
    },
    zoomOut() {
      this.escala = Math.max(0.2, this.escala - 0.25)
      if (this.escala <= 1) {
        this.pan = { x: 0, y: 0 }
      }
    },
    onWheel(e) {
      const delta = e.deltaY < 0 ? 0.15 : -0.15
      this.escala = Math.min(5, Math.max(0.2, this.escala + delta))
      if (this.escala <= 1) {
        this.pan = { x: 0, y: 0 }
      }
    },
    iniciarPan(e) {
      if (this.escala <= 1) return
      this.panAtivo = true
      this.panOrigem = { x: e.clientX - this.pan.x, y: e.clientY - this.pan.y }
      e.preventDefault()
    },
    moverPan(e) {
      if (!this.panAtivo) return
      this.pan = {
        x: e.clientX - this.panOrigem.x,
        y: e.clientY - this.panOrigem.y,
      }
    },
    encerrarPan() {
      this.panAtivo = false
    },
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.moverPan)
    document.removeEventListener('mouseup', this.encerrarPan)
    document.removeEventListener('click', this.fecharReactionPicker)
  },
}
</script>

<style scoped>
.midia-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(11, 20, 26, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  outline: none;
}

.midia-fade-enter-active,
.midia-fade-leave-active {
  transition: opacity 0.18s ease;
}
.midia-fade-enter,
.midia-fade-leave-to {
  opacity: 0;
}

/* ── Header ── */
.midia-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 12px;
  background: rgba(11, 20, 26, 0.85);
  backdrop-filter: blur(4px);
  z-index: 2;
  gap: 12px;
}

/* Avatar + nome + hora */
.midia-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.midia-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.midia-header-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.midia-sender-name {
  color: #fff;
  font-size: 0.92rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.midia-send-time {
  color: rgba(255,255,255,0.55);
  font-size: 0.75rem;
  white-space: nowrap;
}

/* Ações do header */
.midia-header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

/* Botão ícone */
.midia-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.85);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  text-decoration: none;
  padding: 0;
}

.midia-icon-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.12);
  color: #fff;
}

.midia-icon-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

/* Picker de reação */
.midia-reagir-wrapper {
  position: relative;
}

.midia-reaction-picker {
  position: absolute;
  top: 48px;
  right: 0;
  background: #1f2c33;
  border-radius: 24px;
  padding: 6px 10px;
  display: flex;
  gap: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.5);
  z-index: 10;
  white-space: nowrap;
}

.midia-reaction-emoji {
  font-size: 1.3rem;
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;
  transition: transform 0.1s;
}

.midia-reaction-emoji:hover {
  transform: scale(1.3);
}

/* ── Botões de navegação lateral ── */
.midia-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.12);
  color: #fff;
  cursor: pointer;
  z-index: 3;
  transition: background 0.15s;
}

.midia-nav-btn:hover {
  background: rgba(255,255,255,0.25);
}

.midia-nav-btn--left { left: 16px; }
.midia-nav-btn--right { right: 16px; }

/* ── Conteúdo central ── */
.midia-content {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 68px 72px 40px;
}

.midia-img-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform-origin: center center;
  transition: transform 0.08s linear;
  will-change: transform;
}

.midia-img {
  max-width: calc(100vw - 160px);
  max-height: calc(100vh - 130px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  display: block;
  user-select: none;
  -webkit-user-drag: none;
}

.midia-video {
  max-width: calc(100vw - 160px);
  max-height: calc(100vh - 130px);
  border-radius: 4px;
  background: #000;
}

/* ── Legenda ── */
.midia-caption {
  position: absolute;
  bottom: 0;
  left: 50%;
  right: auto;
  transform: translateX(-50%);
  width: 70%;
  max-width: calc(100% - 24px);
  padding: 10px 20px;
  color: #fff;
  font-size: 0.9rem;
  text-align: center;
  box-sizing: border-box;
  max-height: min(38vh, 320px);
  overflow-x: hidden;
  overflow-y: auto;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
  hyphens: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
}

.midia-unsupported {
  color: rgba(255,255,255,0.5);
  font-size: 1rem;
}

@media (max-width: 600px) {
  .midia-nav-btn--left { left: 6px; }
  .midia-nav-btn--right { right: 6px; }
  .midia-content { padding: 68px 12px 40px; }
  .midia-img,
  .midia-video {
    max-width: 100vw;
    max-height: calc(100vh - 130px);
  }
  .midia-header-actions .midia-icon-btn:nth-child(-n+2) {
    display: none;
  }
}
</style>
